import { useCallback } from 'react';

import { toast } from '@/common/components/shared/toaster/toast';
import { useUpdateEmployeePermissionMutation } from '@/common/graphql';
import type { EmployeePermissionFormDataType } from '@/common/types';
import { ApiUtils } from '@/common/utils';

export const useUpdateEmployeePermission = ({ onCompleted }: { onCompleted: VoidFunction }) => {
  const [updateRecord, { loading }] = useUpdateEmployeePermissionMutation();

  const handleUpdateEmployeePermission = useCallback(
    async (formData: EmployeePermissionFormDataType, employeeId: string) => {
      await updateRecord({
        variables: {
          input: {
            companyIds: formData.companyIds,
            employeeIds: formData.isAllEmployees ? [] : formData.employeeIds,
            role: formData.role,
            employeeId,
            idpFullAccess: formData.idpFullAccess,
          },
        },
        onError: error => ApiUtils.handleApiError(error),
        onCompleted: data => {
          if (data.updateEmployeePermission) {
            toast.success();
            onCompleted();
          }
        },
      });
    },
    [onCompleted, updateRecord],
  );

  return {
    handleUpdateEmployeePermission,
    loading,
  };
};
